import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { userSelector } from 'auth/selectors'
import { waitlistStateSelector, waitlistErrorSelector, waitlistIdSelector } from 'subscription-flow/waitlist/selectors'
import {
    getWaitingListState,
    setWaitlistId,
    clearErrorState,
    clearWaitlistState,
} from 'subscription-flow/waitlist/actions'
import { WAITLIST_STATE_PENDING, WAITLIST_FLOW } from 'subscription-flow/waitlist/constants'

const withWaitlist = WrappedComponent => props => {
    const {
        waitlistState,
        getWaitingListState,
        waitlistError,
        setWaitlistId,
        waitlistId,
        user,
        clearErrorState,
        clearWaitlistState,
    } = props
    const urlLocation = useLocation()
    const searchCode = new URLSearchParams(urlLocation.search).get('id')
    const waitlistAvailable = waitlistId && waitlistState === WAITLIST_STATE_PENDING
    const errorMsg = waitlistError ? (
        waitlistError
    ) : waitlistState && !waitlistAvailable ? (
        <T>waiting.list.date.section.error.message</T>
    ) : null
    const isWaitListFlow = useLocation().pathname.split('/')[2] === WAITLIST_FLOW

    useEffect(() => {
        clearWaitlistState()
        clearErrorState()
        isWaitListFlow && searchCode && setWaitlistId(searchCode)
    }, [])

    useEffect(() => {
        isWaitListFlow && user && waitlistId && getWaitingListState()
    }, [user?.id])

    return (
        <WrappedComponent
            waitlistState={waitlistState}
            waitlistId={waitlistId}
            waitlistAvailable={waitlistAvailable}
            waitlistErrorMsg={errorMsg}
            isWaitListFlow={isWaitListFlow}
            {...props}
        />
    )
}

export default WrappedComponent =>
    compose(
        connect(
            createStructuredSelector({
                user: userSelector,
                waitlistId: waitlistIdSelector,
                waitlistState: waitlistStateSelector,
                waitlistError: waitlistErrorSelector,
            }),
            {
                getWaitingListState,
                setWaitlistId,
                clearErrorState,
                clearWaitlistState,
            }
        )
    )(withWaitlist(WrappedComponent))
